import { IApplicationState } from '../../types/redux';

export function getHousesCount(state: IApplicationState) {
  const {
    newbuilding: { housesCount },
  } = state;

  return housesCount;
}
